import "./SplashScreen.scss";
import React, { useEffect, useState } from "react";
import { BhoomiLogoIcon, LogoIcon } from "../../lib/myIcons";

const SplashScreen = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Total splash duration: draw + fill + pause
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onFinish, 500); // fade out duration
    }, 6500);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <>
    
      <div className="splashScreen">
        <div
          id="splash-screen"
          className={fadeOut ? "fade-out" : ""}
          style={{
            position: "fixed",
            inset: 0,
            background: "#fff",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transition: "opacity 0.5s ease",
          }}
        >
          {/* <BhoomiLogoIcon size={100} color="#767575ff" duration={3} /> */}

          <div className="logoBox">


            <LogoIcon className="logoSVG"  size={250} color="gold" />

          </div>


          <div style={{ marginTop: "1rem", fontFamily: "Raleway, sans-serif" }}>
            Opening Doors to Better Living.
          </div>
        </div>

      </div>

    </>
  );
};

export default SplashScreen;
